import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

type ThreadDetailBoxSkeletonProps = {}

export const ThreadDetailBoxSkeleton: FC<ThreadDetailBoxSkeletonProps> = () => (
  <Card elevation={0} sx={{ bgcolor: 'unset', borderRadius: 0 }}>
    <Skeleton variant="rectangular" width="100%" height={281} />
    <CardContent>
      <SkeletonText variant="large" numberOfLine={2} lastWidth="75%" />
      <Stack
        flex={1}
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ pt: 9, pb: 3 }}
      >
        <Skeleton variant="circular" width={28} height={28} />
        <SkeletonText variant="small" width="25%" />
      </Stack>
      <SkeletonText variant="medium" numberOfLine={3} lastWidth="75%" />
    </CardContent>
    <Stack sx={{ height: 56 }} />
  </Card>
)
